import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Modelo } from '../../shared/models/modelo';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ModeloService {
  private apiUrl = `${environment.apiUrl}/modelos`;

  constructor(private http: HttpClient, private auth: Auth) { }

  private getHeaders() {
    const token = this.auth.getToken();
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
  }

  getAllModelos(): Observable<Modelo[]> {
    return this.http.get<Modelo[]>(this.apiUrl, this.getHeaders());
  }

  getModelosByCategory(categoryId: number): Observable<Modelo[]> {
    return this.http.get<Modelo[]>(`${this.apiUrl}/category/${categoryId}`, this.getHeaders());
  }

  createModelo(modelo: Modelo): Observable<Modelo> {
    return this.http.post<Modelo>(this.apiUrl, modelo, this.getHeaders());
  }

  updateModelo(id: number, modelo: Modelo): Observable<Modelo> {
    return this.http.put<Modelo>(`${this.apiUrl}/${id}`, modelo, this.getHeaders());
  }

  toggleStatus(id: number): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/toggle`, {}, this.getHeaders());
  }
}